import { render, staticRenderFns } from "./infotime.vue?vue&type=template&id=28e4a395&scoped=true&"
import script from "./infotime.vue?vue&type=script&lang=js&"
export * from "./infotime.vue?vue&type=script&lang=js&"
import style0 from "./infotime.vue?vue&type=style&index=0&id=28e4a395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e4a395",
  null
  
)

export default component.exports